'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import * as React from 'react';
import { Fragment } from 'react';
import { NavPathname } from '@/components/NavPathname';
import { SidebarGroup, SidebarMenu, SidebarMenuBadge, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
type Item = {
  title: string;
  url: string;
  icon: React.ReactNode;
  badge?: React.ReactNode;
};
export function NavSecondary(t0) {
  const $ = _c(10);
  let items;
  let props;
  if ($[0] !== t0) {
    ({
      items,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = items;
    $[2] = props;
  } else {
    items = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== items) {
    t1 = items.map(_temp);
    $[3] = items;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <SidebarMenu>{t1}</SidebarMenu>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2) {
    t3 = <SidebarGroup {...props}>{t2}</SidebarGroup>;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(item) {
  return <NavPathname key={item.title}>{pathname => <SidebarMenuItem className="flex"><Fragment><SidebarMenuButton isActive={pathname === item.url} asChild={true}><Link href={item.url} className="flex">{item.icon}<span>{item.title}</span></Link></SidebarMenuButton>{item.badge && <SidebarMenuBadge>{item.badge}</SidebarMenuBadge>}</Fragment></SidebarMenuItem>}</NavPathname>;
}